/**
 * Shared design tokens for the workflow-template screens (builder + AI planner),
 * so the two views read as one surface.
 */

export const P = "#3730a3", PL = "#eef2ff", BORDER = "#e5e7eb";
export const ACCENT = "#4f46e5";          // indigo-600 — node accent, draft edge
export const INK = "#0f172a", MUTED = "#64748b", LINE = "#e2e8f0";
export const SYNTH_ACCENT = "#7c3aed";

export const CARD_SHADOW = "0 1px 2px rgba(15,23,42,0.06), 0 8px 20px rgba(15,23,42,0.04)";
export const CANVAS_BG =
  "radial-gradient(circle at 18% 0%, rgba(79,70,229,0.07), transparent 55%), linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)";

export const inp = {
  width: "100%", padding: "8px 11px", fontSize: "13px",
  border: `1px solid ${BORDER}`, borderRadius: "6px",
  boxSizing: "border-box", color: "#1f2937", background: "#fff",
};
export const lbl = { display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "4px" };
export const outBtn = {
  padding: "8px 14px", fontSize: "12px", fontWeight: 600,
  background: "#fff", color: P, border: `1px solid ${P}`, borderRadius: "6px", cursor: "pointer",
};
export const chip = {
  display: "inline-block", padding: "2px 7px", borderRadius: "999px",
  fontSize: "10px", fontWeight: 700, whiteSpace: "nowrap",
};
export const truncate = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
